import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXApp_SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [
        {
          id: 3,
          text01: "CityX BillBox",
          text02:
            "CITYX u gradovima koji su osigurali ovu slugu omogućuje sigurno plaćanje mjesečnih troškova! Provjeri stanje duga za komunalne naknade, članarine i druge režije. Sve to jednim klikom!",
        },
        {
          id: 4,
          text01: "Gradonačelnikov dnevnik",
          text02:
            'Zanimljiv i koristan modul za vođenje kronike lokalne samouprave, pregleda bitnih datuma, infrastrukturnih realizacija, događanja. Zamišljen je u formi "dnevnika gradonačelnika" u kojem se kronološi navode projekti i realizacije.',
        },
        {
          id: 5,
          text01: "Prijava kvarova",
          text02:
            "Modul kroz kojeg se na jednostavan naćin prijavljuje bilo koja nepravilnost, oštečenje gradske imovine i usmjerava rad gradskih službi na otklanjanje problema. Vrlo važan modul koji osim što pomaže u detekciji problema, građane aktivno uključuje u proces održavanja grada u kojem je ugodno boraviti.",
        },
        {
          id: 6,
          text01: "Infoservis",
          text02:
            "Ovaj modul je zamišljen kao odgovor na sva pitanja koja se mogu postaviti vezano uz grad. Koja služba? Tko je zadužen? Gdje i kako stupiti u kontakt? Modul Infoservis ti nudi sve odgovore!",
        },
        {
          id: 7,
          text01: "Ocijeni me!",
          text02:
            "Ugodno ste se iznenadili ljubaznošću u gradskoj službi? Vaš zahtjev je brzo obrađen uz veliku profesionalnost Upravnog odjela. Nešto bi ipak moglo biti bolje? Kroz ovaj modul možete izraziti svoje mišljenje!",
        },
        {
          id: 8,
          text01: "Public Alert System (PAS)",
          text02:
            "Na žalost katastrofe se dešavaju, a u tim okolnostima mnoge sredine imaju komunikacijske probleme s građanima. Ovaj modul je napravljen da se unutar nekoliko sati prilagodi nastaloj situacije, te posluži kao kanal za informiranje i organiziranje pomoći. Modul je dostupan u svim gradovima s kojima je ugovorena suradnja!",
        },
      ],
      cores: [
        { title: "Novosti i događanja" },
        { title: "Ankete" },
        { title: "Pregled svih institucija" },
        { title: "Pregled relevantnih poslovnih subjekata" },
        { title: "Akcijske ponude i promocije" },
        { title: "Ocjenjivanje zadovoljstva građana" },
      ],
    };
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-row equalize sm-equalize-auto clearfix">
            <div className="span_1_of_6 bg-f7f">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={60}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-content-box clearfix"
                data-margin="0 10px 0 43px"
                data-mobilemargin="0 15px 0 15px"
              >
                <div className="themesflat-headings style-2 clearfix">
                  <div className="sup-heading">
                    Mobilna aplikacija tvog grada
                  </div>
                  <h2 className="heading font-size-28 line-height-39">
                    CITY<b>X</b> APP
                  </h2>
                  <div className="sep has-width w80 accent-bg margin-top-20 clearfix" />
                  <p className="sub-heading margin-top-33 line-height-24">
                    Aplikacija koja se bavi aktualnostima u tvom gradu, a
                    istovremeno čini jedinstvenu mrežu digitalnih gradova! Što
                    (i kako) rade gradske vlasti? Što se novo nudi? Gdje se što
                    nalazi? Koja su događanja i što ti misiš o svemu!
                    <br />
                    PRIDRUŽI SE JOŠ DANAS jedinstvenoj aplikaciji za moderne
                    gradove i građane!
                  </p>
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={56}
                data-mobile={56}
                data-smobile={56}
              />
            </div>
            <div
              className="span_1_of_6 half-background "
              style={{
                backgroundImage: "url(../assets/img/apps/cityx-app.jpg",
              }}
            ></div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={39}
            data-mobile={39}
            data-smobile={39}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title">
              ŠTO JE CITY<b>X</b> APP?
            </h5>
            <p>
              <b>CityX je mobilna aplikacija</b> iz domene{" "}
              <b>
                <i>smart city app</i>
              </b>{" "}
              namjenjena građanima i gostima grada, koja kroz intuitivno sučelje
              nudi brojna rješenja i pomaže u različitim aspektima života. CityX
              je sustav koji čini <b>mrežu europskih gradova</b>, a kroz svoju
              prvu fazu izvedbe poseban fokus je na hrvatskim gradovima i
              općinama.
              <br />
              <br />
              Vaš ulazak u aplikaciju započinje odabirom grada, a ovisno o
              razini suradnje s lokalnom upravom i tvrtkama, biti će Vam
              dostupne različite razine digitalnih rješenja tj. modula. CityX
              aplikaciju čine tri osnovne grupe funkcionalnosti i to iz domene
              informiranja, lokalne usprave te dijela koji okuplja lokalnu
              ponudu. Svaka grupa sadrži specijalizirane modularnosti s
              naprednim rješenjima.
              <br />
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <div className="item">
              <div className="inner">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={10}
                  data-mobile={10}
                  data-smobile={10}
                />
                <h5 className="title">
                  CITY<b>X</b> APP OSNOVNI MODULI:
                </h5>
                <p>
                  Aplikacija u svim gradovima nudi dostupnost osnovnih modula
                  koji se, naravno, mogu proširiti u suradnju s gradskom
                  upravom, turističkom zajednicom, komunalnim poduzećem ili
                  nekom drugom gradskom službom. Osnovi moduli uključuju:
                </p>
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={8}
                  data-mobile={8}
                  data-smobile={8}
                />
                {this.state.cores.map((data) => (
                  <div className="themesflat-list has-icon style-1 icon-left size-16 clearfix">
                    <div className="inner">
                      <span className="item">
                        <span className="icon">
                          <i className="fa fa-check-circle" />
                        </span>
                        <span className="text">{data.title}</span>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="item">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={0}
                data-mobile={0}
                data-smobile={35}
              />

              <div
                className="themesflat-content-box clearfix"
                data-margin="0 0 0 11px"
                data-mobilemargin="0 0 0 0"
              >
                <div className="inner pd35 bg-ffc">
                  <h5 className="title text-white line-height-24 padding-left-7">
                    PREUZMITE PREZENTACIJSKE MATERIJALE ZA CITYX APP
                  </h5>
                  <br />
                  <div
                    className="themesflat-spacer clearfix"
                    data-desktop={16}
                    data-mobile={16}
                    data-smobile={16}
                  />
                  <div className="button-wrap has-icon icon-right size-14">
                    <a
                      href="/assets/pdf/CITYX Brošura 01.pdf"
                      className="themesflat-button bg-white color-333 w100 font-weight-400 no-letter-spacing pd26"
                      download
                    >
                      <span>
                        Preuzmi prezentacijski .PDF{" "}
                        <span className="icon">
                          <i className="fa fa-file-pdf-o" />
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <h5 className="title no-letter-spacing">
              PROŠIRENI MODULI CITYX-a:
            </h5>
            <div
              className="themesflat-spacer clearfix"
              data-desktop={27}
              data-mobile={27}
              data-smobile={27}
            />
            <div className="themesflat-tabs style-2 title-w170 clearfix">
              <ul className="tab-title clearfix ">
                <li className="item-title active">
                  <span className="inner">Transparentnost</span>
                </li>
                <li className="item-title">
                  <span className="inner">Transport</span>
                </li>
                <li className="item-title">
                  <span className="inner">BillBox</span>
                </li>
                <li className="item-title">
                  <span className="inner">Gradonačelnikov dnevnik</span>
                </li>
                <li className="item-title">
                  <span className="inner">Prijava kvarova</span>
                </li>
                <li className="item-title">
                  <span className="inner">Infoservis</span>
                </li>
                <li className="item-title">
                  <span className="inner">Ocijeni me</span>
                </li>
                <li className="item-title">
                  <span className="inner">Public Alert System (PAS)</span>
                </li>
              </ul>

              <div className="tab-content-wrap clearfix">
                <div className="tab-content" key={1}>
                  <div className="item-content">
                    <p>
                      <b>CITYX TRANSPARENTNOST PRORAČUNA</b>
                    </p>
                    <p>
                      Sva tijela javne vlasti obvezna su na internetskim
                      stranicama javno objavljivati niz podataka vezanih uz
                      njihovo područje rada, a osobito podatke o izvorima
                      financiranja, proračunu, izvršenju proračuna i
                      financijskom planu, kao i podatke o dodijeljenim
                      bespovratnim sredstvima i pomoćima, odnosno podatke u
                      smislu propisa kojim se uređuje područje javne nabave.
                      <br />
                      <br />
                      Stupanjem na snagu Zakona o izmjenama i dopunama Zakona o
                      lokalnoj i područnoj (regionalnoj) samoupravi (NN 144/20),
                      kao jednu od najznačajnijih zakonskih novina ističemo
                      uvođenje obveze svim jedinicama lokalne i područne
                      samouprave na internetsku objavu potrošenih javnih
                      sredstava, na način da informacije budu lako dostupne i
                      pretražive. Odredba članka 68.a Zakona o lokalnoj i
                      područnoj (regionalnoj) samoupravi (NN 33/01, 60/01,
                      129/05, 10/07, 125/08, 36/09, 36/09, 150/11, 144/12,
                      19/13, 137/15, 123/17, 98/19 i 144/20,dalje: ZLP(R)S)
                      glasi:
                      <br />
                      <br />
                      Članak 68.a
                      <br />
                      Općina, grad i županija dužne su javno objaviti
                      informacije o trošenju proračunskih sredstava na svojim
                      mrežnim stranicama tako da te informacije budu lako
                      dostupne i pretražive.
                      <br />
                      <br />
                      Transparentni proračun omogućuje uvid u potpune, točne,
                      pravovremene i razumljive informacije o proračunu pa
                      građani mogu vlastitim angažmanom utjecati na efikasnost
                      prikupljanja javnih sredstava i ponude javnih dobara i
                      usluga, na povećanje odgovornosti regionalnih/lokalnih
                      vlasti i smanjenje mogućnosti za korupciju. Naš projekt se
                      bazira na svakodnevnom radu što boljeg prikaza proračunske
                      transparentnosti, kako bi ista bila u skladu sa svim
                      propisima te u skladu sa kriterijima Instituta za javne
                      financije, a sve kako bi naši korisnici imali najveću
                      razinu transparentnosti.
                      <br />
                      <br />
                      Ukoliko se odlučite na korištenje našeg rješenja u
                      području transparentnosti, možemo Vam ponuditi: <br />
                      <b>1.</b> Pregled isplata - isplate iz proračuna
                      <br />
                      <b>2.</b> Financijska izvješća - sva izvješća koja je
                      lokalna samouprava dužna objaviti te grafički prikazi po
                      godinama koji se odnose na potrošnju
                      <br />
                      <b>3.</b> Evidencija ugovora / Pregled dokumenata -
                      mogućnost evidencija raznih ugovora (npr ugovori o
                      stipendiji, pomoć udrugama) i njihova objava,a sve putem
                      tražilice i evidencijskog sustava
                      <br />
                      <b>4.</b> Registar Javne nabave - pregled narudžbenica i
                      ugovora
                      <br />
                      <b>5.</b> Evidencija ugovora o zakupu - pregled ugovora i
                      svih relevantnih podataka kroz tražilicu
                      <br />
                      <b>6.</b> Vizualizacija proračuna - grafički prikazi
                      <br />
                      <br />
                      Za potrebe usklađenja, osigurali smo za Vas i pravnu
                      podršku.
                      <br />
                      Osim jedinica lokalne samouprave, transparentnost možemo
                      integrirati u razne sustave za sva tijela javne vlasti te
                      za sve strukovne organizacije sa javnim ovlastima.
                      <br />
                      <br />
                      <b>Iz medija:</b>
                      <br /> <br />
                      Istarski.hr:{" "}
                      <a href="https://istarski.hr/node/73520-sada-imamo-i-prvi-cityx-apps-transparentor-grad-u-istri">
                        Sada imamo i prvi CityX Apps Transparentor grad u Istri
                      </a>
                      <br />
                      Index.hr:{" "}
                      <a href="https://www.index.hr/vijesti/clanak/od-sada-svi-mogu-vidjeti-place-i-troskove-koji-se-isplacuju-iz-proracuna-labina/2284414.aspx">
                        Od sada svi mogu vidjeti plaće i troškove koji se
                        isplaćuju iz proračuna Labina
                      </a>
                      <br />
                      N1:{" "}
                      <a href="https://hr.n1info.com/vijesti/odsad-svi-mogu-vidjeti-troskove-grada-labina/">
                        Odsad svi mogu vidjeti troškove Grada Labina
                      </a>
                    </p>
                  </div>
                </div>

                <div className="tab-content" key={2}>
                  <div className="item-content">
                    <p>
                      <b>CityX Transport</b>
                    </p>
                    <p>
                      Modul koji se bavi tematikom javnog prevoza s naglaskom na
                      informiranje o voznom redu, pozicijama stajališta, točnoj
                      lokaciji i vremenu dolaska. Uz spomenuto u sklopu ovog
                      modula nudimo informacije o svim dostupnim prevoznim
                      sredstvima iz domene "Clean transport" kroz suradnju s
                      tvrtkama iz tog područja.
                      <br />
                      <br />
                      <img src="/assets/img/_illustrations/scooter.jpg" />
                    </p>
                  </div>
                </div>
                {this.state.tabs.map((data) => (
                  <div className="tab-content" key={data.id}>
                    <div className="item-content">
                      <p>
                        <b>{data.text01}</b>
                      </p>
                      <p>{data.text02}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default CityXApp_SiteContent;
